import React from "react";
import { Toast, Button, List, InputItem, Modal } from "antd-mobile";
import { post } from "../../utils/request";
import { href, viewPort } from "../../utils/util";

import api from "./api";

import "./index.less";
class vehicleInquiry extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      urlOps: { carPlateNumber: "" },
      dialogShow: false,
    };
  }

  componentDidMount() {
    window.didEnterNumber = this.didEnterNumber;
    var obj = "",
      obj1 = "",
      ops = {};
    let newUrl = decodeURI(window.location.href);
    if (newUrl.indexOf("?") > -1) {
      obj = newUrl.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
      this.setState({
        urlOps: {
          app_stoken: ops.app_stoken || "",
          carPlateNumber: ops.carPlateNumber || "",
        },
      });
    }
  }

  viewPort = () => {
    let u = navigator.userAgent.toLowerCase();
    return {
      isWeixin: u.indexOf("micromessenger") > -1,
      isQQ: u.indexOf("qq/") > -1,
      trident: u.indexOf("trident") > -1, //IE内核
      presto: u.indexOf("presto") > -1, //opera内核
      webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
      mobile: !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
      android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
      iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("ipad") > -1, //是否iPad
      webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
    };
  };

  didEnterNumber(carPlateNumber) {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
    }
    let url = encodeURI(
      window.location.origin +
        "/payment/#/vehicleInquiry?app_stoken=" +
        ops.app_stoken +
        "&carPlateNumber=" +
        carPlateNumber
    );

    let v = viewPort();
    if (v.ios || v.iPhone || v.iPad) {
      if (window.webkit) {
        window.location.replace(url);
        window.location.reload();
      }
    } else {
      if (window.huilian) {
        window.huilian.goBack("");
        window.huilian.openNewWeb(url);
      }
    }
  }

  openInput() {
    let viewPort = this.viewPort();
    if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
      if (window.webkit) {
        window.webkit.messageHandlers.enterCarPlateNumber.postMessage("");
      }
    } else {
      if (window.huilian) {
        window.huilian.enterCarPlateNumber("");
      }
    }
  }

  // 申请
  submit() {
    const { urlOps } = this.state;
    const viewPortData = viewPort();
    let app_stoken = "";
    let phoneNumber = "";
    if (viewPortData.ios || viewPortData.iPhone || viewPortData.iPad) {
      if (window.webkit) {
        app_stoken = window.prompt("getAppToken", "");
        phoneNumber = window.prompt("getPhoneNumber", "");
      }
    } else {
      if (window.huilian && window.huilian.getAppToken) {
        app_stoken = window.huilian.getAppToken();
        phoneNumber = window.huilian.getPhoneNumber();
      }
    }
    post({
      url: api.checkCarPlateNumber + "?app_stoken=" + app_stoken,
      data: { carPlateNumber: urlOps.carPlateNumber },
    }).then(
      (res) => {
        if (res.result === "success") {
          let url = encodeURI(
            "/vehicleInquiryInputPage?phoneNumber=" +
              phoneNumber +
              "&carPlateNumber=" +
              urlOps.carPlateNumber
          );
          href(url);
        } else {
          // this.setState({
          //   dialogShow: true,
          // });
        }
      },
      (res) => {
        // Toast.info("查询失败", 1);
      }
    );
  }

  render() {
    const { urlOps, dialogShow } = this.state;
    return (
      <div className="vehicleInquiryBox">
        <div className="registerBox">
          <div>
            <div className="registerTitle"></div>

            <div className="registerText">车辆查询</div>
            <List
              style={{
                marginTop: "0.15rem",
                marginBottom: "0.19rem",
                padding: "0 0.12rem",
              }}
            >
              <div
                onClick={() => {
                  this.openInput();
                }}
              >
                <InputItem
                  type="money"
                  moneyKeyboardAlign="right"
                  editable={false}
                  extra={
                    urlOps.carPlateNumber == "" ? (
                      <a size="small" style={{ marginLeft: "0.1rem" }}>
                        请输入
                      </a>
                    ) : (
                      <a
                        size="small"
                        style={{ marginLeft: "0.1rem", color: "#333" }}
                      >
                        {urlOps.carPlateNumber}
                      </a>
                    )
                  }
                >
                  车牌号
                </InputItem>
              </div>
            </List>
          </div>
          <div style={{ marginTop: "0.3rem", padding: "0 0.12rem" }}>
            <div
              className="reward_3_row"
              onClick={() => {
                this.submit();
              }}
            >
              查询车辆是否在服务范围内
            </div>
          </div>
        </div>
        <Modal
          visible={dialogShow}
          transparent
          maskClosable={false}
          title=""
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({
                  dialogShow: false,
                });
              },
            },
          ]}
        >
          <div>抱歉，您的车辆不在服务范围内</div>
        </Modal>
      </div>
    );
  }
}

export default vehicleInquiry;



// WEBPACK FOOTER //
// ./src/vehicleInquiry/index/index.js